import { FC } from 'react';
import { useFormikContext } from 'formik';

import CTAButton, { CTAButtonProps } from '@/components/ui/CTAButton';

export type SubmitButtonProps = Omit<
  CTAButtonProps,
  'onClick' | 'disabled' | 'loading'
>;

const SubmitButton: FC<SubmitButtonProps> = ({ variant = 'secondary', ...props }) => {
  const { isSubmitting } = useFormikContext();

  return <CTAButton {...props} variant={variant} type="submit" loading={isSubmitting} />;
};

export default SubmitButton;
